import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { SidebarFiltersService } from '@molecules/sidebar-filters/sidebar-filters.service';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { Subscription, combineLatest, switchMap } from 'rxjs';

@Component({
  selector: 'app-control-page-sidebar',
  templateUrl: './control-page-sidebar.component.html',
  styleUrls: ['./control-page-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SidebarFiltersService,
  ],
})
export class ControlPageSidebarComponent implements OnInit {

  private sub = new Subscription();

  private filter$ = toObservable(this.sidebarFiltersService.selectedFilter);

  private showHomeCard$ = combineLatest({
    showHomeCard: this.controlPageCardService.showHomeCard$,
    filter: this.filter$,
  }).pipe(
    switchMap(({showHomeCard}) => this.sidebarFiltersService.filterShowHomeCard(showHomeCard)),
  );

  private showModeControlCard$ = combineLatest({
    showModeControlCard: this.controlPageCardService.showModeControlCard$,
    filter: this.filter$,
  }).pipe(
    switchMap(({showModeControlCard}) => this.sidebarFiltersService.filterShowModeControlCard(showModeControlCard)),
  );

  viewModel$ = combineLatest({
    showHomeCard: this.showHomeCard$,
    showModeControlCard: this.showModeControlCard$,
  });

  constructor(
    private homesFacade: HomesFacade,
    private controlPageCardService: ControlPageCardService,
    private sidebarFiltersService: SidebarFiltersService,
  ) { }

  async ngOnInit() {
    this.sub.add(this.homesFacade.currentHomeId$.pipe(isDefined())
      .subscribe(() => this.controlPageCardService.selectFirstCard())
    );
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

}
